const state = {
	favoriteMarkets: localStorage.getItem("favorite-markets")
		? JSON.parse(localStorage.getItem("favorite-markets"))
		: [],
};

const persistFavorites = (favorites) => {
	localStorage.setItem("favorite-markets", JSON.stringify(favorites));
};

const getters = {
	favoriteMarkets: (state) => {
		return state.favoriteMarkets ? state.favoriteMarkets : [];
	},
};

const actions = {
	addToFavorites({ commit }, payload) {
		commit("setMarketFavorites", payload);
	},
};

const mutations = {
	setMarketFavorites(state, data) {
		let favorites = state.favoriteMarkets;
		// console.log("Favorites from payload: ", data);
		let exists =
			favorites.findIndex((market) => market.sub_type_id == data.sub_type_id) > -1;

		if (exists) {
			state.favoriteMarkets = state.favoriteMarkets.filter(function (
				market
			) {
				return market.sub_type_id != data.sub_type_id;
			});
		} else {
			state.favoriteMarkets.push(data);
		}

		// console.log("Favorites: ", state.favoriteMarkets);
		persistFavorites(state.favoriteMarkets);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};